module.exports = __webpack_public_path__ + "static/media/upload-banner.3df440c9.jpg";